import React from 'react'
import { Image } from '../image/image'

export class ArticleImageContainer extends React.Component {
  render() {
    return (
      <figure className="post-cover__media-wrap post-cover__media-wrap--image">
        <Image
          lazyLoad={this.props.lazy_load}
          src={this.props.url}
          srcSet={this.props.srcset}
          className="post-cover__media post-cover__media--image"
          title={this.props.credit}
          alt={this.props.caption}
        />
      </figure>
    )
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/article_image/articleImage.container.js